import { useEffect } from "react";

import { KeyBy } from "@m7-health/shared-utils";
import { keyBy } from "lodash";

import { useAppConfigQuery } from "#/features/User/queries";
import { IStaffType } from "@/api";
import { useDeepMemo } from "@/common/hooks";

import { TAppConfigState, useAppConfigDispatch } from "../../store";

import type { PayloadAction } from "@reduxjs/toolkit";

export type IStaffTypeState = {
  staffTypes: IStaffType[];
  staffTypeByKey: KeyBy<IStaffType, "key">;
};

export const staffTypeInitialState: IStaffTypeState = {
  staffTypes: [],
  staffTypeByKey: {},
};

export const staffTypeActions = {
  setStaffTypes: (
    { staffType: state }: TAppConfigState,
    { payload }: PayloadAction<{ staffTypes: IStaffType[] }>,
  ) => {
    state.staffTypes = payload.staffTypes;
    state.staffTypeByKey = keyBy(payload.staffTypes, "key");
  },
};

export const useSynchStaffTypes = () => {
  const dispatch = useAppConfigDispatch();
  const appConfig = useAppConfigQuery();

  const staffTypes = useDeepMemo(() => appConfig.data?.staffTypes, [appConfig.data?.staffTypes]);

  useEffect(() => {
    if (!staffTypes?.length) return;

    dispatch.setStaffTypes({ staffTypes });
  }, [staffTypes, dispatch]);
};
